import { enUS_Promotion } from "./promotion";
import { enUS_sideBar } from "./sideBar";
import { enUS_Transaction } from "./transaction";

const en_US = {
  ...enUS_sideBar,
  ...enUS_Transaction,
  ...enUS_Promotion
};
 export default en_US;